import React from "react";
import moment from "moment";
import { buscarInscritosDeUmaGRU } from "../../actions/GRUActions";
import { buscarInscritosDeUmaGruSortDesc } from "../../actions/GRUActions";
import { formatLongToDate } from "../../../../helpers/Data";
import {
  View,
  LinkAction,
  Table,
  TableColumn,
  FieldsGroup,
  FieldDetail
} from "react-template";
import "../../../../assets/css/view/gru/list/tabs/GRUSubscribed.css";

class GRUSubscribed extends View {
  constructor(props) {
    super(props);
    const idGRU = this.props.params.id;
    this.state = {
      data: null,
      url: `/historico/grus/${idGRU}`,
      camposFiltrando: "",
      activeLoader: true
    };
  }

  formatData(resData) {
    let content = [];
    resData.content.forEach(item => {
      let id = item.id;
      let nome = item.nome;
      let cpfCnpj = item.cpfCnpj;
      let tituloGRU = JSON.parse(item.gru.formSchema).schema.title;
      let dataSubmissao = item.dataSubmissao;
      let statusPagamento = item.statusPagamento;
      let dadosForm = item.dadosForm;
      let gru = item.gru;
      content.push({
        id,
        nome,
        cpfCnpj,
        tituloGRU,
        dataSubmissao,
        statusPagamento,
        dadosForm,
        gru
      });
    });
    //ordenando alista por dataSubmissao

    resData.content = content.sort(function(a, b) {
      return b.dataSubmissao - a.dataSubmissao;
    });
    return resData;
  }

  componentDidMount() {
    this.getForms(this.state.url + "?size=10");
  }

  onPaginator = url => {
    this.getForms(url + this.state.camposFiltrando);
  };

  onFilter = camposFiltrando => {
    const url = this.state.url + "?size=10" + camposFiltrando;
    this.setState({ camposFiltrando });
    this.getForms(url, true);
  };

  getForms = (url, filtrando = false) => {
    buscarInscritosDeUmaGruSortDesc(
      url,
      res => {
        if (filtrando && res.data.numberOfElements === 0) {
          this.setState({ camposFiltrando: "" });
          this.noResultOnFilter();
          return;
        }
        const resData = this.formatData(res.data);
        this.setState({ data: resData, activeLoader: false });
      },
      error => {
        this.setState({ activeLoader: false });
        this.notifyError("Erro ao carregar histórico", "");
      }
    );
  };

  showHistoricoGRU(e, data) {
    e.preventDefault();
    this.displayModal(
      "Informações do boleto",
      "Informações do boleto gerado por " +
        data.nome +
        " no dia " +
        formatLongToDate(data.dataSubmissao),
      this.contentModal(data)
    );
  }

  contentModal(submissao) {
    let arraySubmissao = this.getItensDeUmaSubmissao(submissao);
    const statusPagamentoClass = submissao.statusPagamento
      ? "status-pago"
      : "status-devendo";
    return (
      <div>
        <hr className={`hr-status-pagamento-modal ${statusPagamentoClass}`} />
        <FieldsGroup>
          {arraySubmissao.map(item => (
            <FieldDetail width={4} titulo={item.titulo}>
              {item.resposta}
            </FieldDetail>
          ))}
        </FieldsGroup>
      </div>
    );
  }

  getItensDeUmaSubmissao(content) {
    let itensSubmissao = [];
    let dadosFormJson = JSON.parse(content.dadosForm);
    const formSchema = JSON.parse(content.gru.formSchema);
    for (let itemName in dadosFormJson) {
      const itemSubmissao = dadosFormJson[itemName];
      const itemTitulo =
        formSchema.schema.properties[itemName] !== undefined
          ? formSchema.schema.properties[itemName].title
          : "Questão removida do formulário";
      itensSubmissao.push({ titulo: itemTitulo, resposta: itemSubmissao });
    }
    return itensSubmissao;
  }

  getTooltipText(statusPagamento) {
    return statusPagamento
      ? "Boleto pago"
      : "Aguardando confirmação do pagamento";
  }

  dataMapper = data => {
    return (
      <tr key={data.id}>
        <TableColumn
          width="20"
          headers="nome"
          content={data.nome}
          label="Nome"
          filter={{ atributo: "nome", coluna: "Nome", tipo: "String" }}
        />
        <TableColumn
          width="30"
          headers="cpfCnpj"
          content={data.cpfCnpj}
          label="CPF / CNPJ"
          filter={{
            atributo: "cpfCnpj",
            coluna: "CPF/CNPJ (só números)",
            tipo: "String"
          }}
        />
        <TableColumn
          width="5"
          headers="dataSubmissao"
          content={formatLongToDate(data.dataSubmissao)}
          label="Data da submissão"
          filter={{
            atributo: "dataSubmissao",
            coluna: "Data da submissão",
            tipo: "Date"
          }}
        />
        <TableColumn
          width="5"
          headers="statusPagamento"
          content={data.statusPagamento}
          label="Pagamento"
          status
          tooltip
          filter={{
            atributo: "statusPagamento",
            coluna: "Pagamento",
            tipo: "Boolean"
          }}
        />
        <TableColumn width="5" headers="acoes" action>
          <LinkAction
            icone="more"
            type="table"
            onClick={e => this.showHistoricoGRU(e, data)}
            tooltip="Detalhar"
          />
        </TableColumn>
      </tr>
    );
  };

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  render() {
    return (
      <div>
        <Table
          title="Inscritos"
          summary={"Consulte quem gerou boleto para a GRU"}
          url={this.state.url}
          data={this.state.data}
          onFilter={this.onFilter}
          dataMapper={this.dataMapper}
          onPaginator={this.onPaginator}
          displayLoading={this.state.activeLoader}
          card
          noPadding
        />
      </div>
    );
  }
}

export default GRUSubscribed;



// WEBPACK FOOTER //
// ./src/view/gru/list/tabs/GRUSubscribed.js